import React from "react";
import { Button } from "./ui/button";
import { media, bookingUrl, translations } from "../mock";
import { useLang } from "../i18n/LanguageContext";
import useReveal from "../hooks/useReveal";

function Phone({ src, title }) {
  return (
    <div className="flex flex-col items-center">
      <div className="relative w-[210px] h-[430px] rounded-[2.4rem] bg-slate-900 p-2.5 shadow-2xl device-shadow">
        <div className="absolute top-2.5 left-1/2 -translate-x-1/2 h-5 w-24 rounded-b-2xl bg-slate-900 z-10" />
        <div className="h-full w-full overflow-hidden rounded-[2rem] bg-white">
          <img src={src} alt={title} className="h-full w-full object-cover object-top" />
        </div>
      </div>
      {title ? <p className="mt-5 font-display font-semibold text-navy text-center text-sm">{title}</p> : null}
    </div>
  );
}

export default function AppShowcase() {
  const { ref, visible } = useReveal();
  const { lang } = useLang();
  const T = translations[lang];
  const a = T.appShowcase;

  return (
    <section id="app" className="py-24 md:py-28 overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm font-bold uppercase tracking-widest text-cblue">{a.eyebrow}</span>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-extrabold text-navy leading-tight">{a.title}</h2>
          <p className="mt-4 text-slate-600">{a.subtitle}</p>
        </div>
        <div ref={ref} className={`mt-14 flex flex-wrap justify-center gap-10 md:gap-16 reveal ${visible ? "is-visible" : ""}`}>
          {media.appScreens.map((src, i) => (<Phone key={i} src={src} title={a.screens[i]} />))}
        </div>
        <div className="mt-14 text-center">
          <p className="text-slate-600 max-w-xl mx-auto">{a.note}</p>
          <Button onClick={() => { window.location.href = bookingUrl; }} className="mt-6 bg-navy hover:bg-navy-800 text-white rounded-full h-14 px-8 text-base font-semibold">
            {T.cta}
          </Button>
        </div>
      </div>
    </section>
  );
}
